(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["scroll-reveal"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.documentElement;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const design = window.Shopify && window.Shopify.designMode;

    const revealAll = (scope) => {
      (scope || document).querySelectorAll('[data-reveal]').forEach((el) => {
        el.classList.add('is-revealed');
      });
    };

    // No observer support, reduced motion, or editor: just show everything.
    if (!('IntersectionObserver' in window) || reduce || design) {
      root.setAttribute('data-reveal-ready', '');
      revealAll(document);
      if (design) {
        document.addEventListener('shopify:section:load', (e) => revealAll(e.target));
      }
      return;
    }

    root.setAttribute('data-reveal-ready', '');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });

    const scan = (scope) => {
      (scope || document).querySelectorAll('[data-reveal]:not(.is-revealed)').forEach((el) => {
        observer.observe(el);
      });
    };

    scan(document);
    document.addEventListener('shopify:section:load', (e) => scan(e.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
